module.exports = __webpack_public_path__ + "img/_homePad_logo_light.51c5a701.svg";